<template>
  <div>
    <div class="tabs-container">
      <v-tabs class="tabs">
        <div class="tab-btns">
          <v-tab id="all-recordings">
            <v-icon>tv</v-icon>
            &nbsp;Recordings
          </v-tab>
          <v-tab id="all-issues">
            <v-icon>list</v-icon>
            &nbsp;All Issues
          </v-tab>
        </div>
        <v-tab-item key="0">
          <Recordings />
        </v-tab-item>
        <v-tab-item key="1">
          <Issues />
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import Issues from './Issues';
import Recordings from './Recordings';

export default {
  name: 'ProjectOverview',
  components: {
    Issues,
    Recordings,
  },
  data() {
    return {
      active: null,
    };
  },
};
</script>

<style lang="scss">
@media (min-width: 450px) {
  .tabs-container {
    .tabs__container {
      height: 58px;
    }
    .tabs__bar {
      border-bottom: 1px solid gainsboro;
    }
    .tab-btns {
      .tabs__div {
        .tabs__item {
          padding: 20px;
        }
      }
      margin-left: 100px;
    }
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectOverview.vue